import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface EngineeringProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Engineering: React.FC<EngineeringProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [engineering, set_engineering] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Setup']?.['Engineering'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Setup': { ...b.values?.['Setup'], 'Engineering': v } } })
    );
    const label = 'Engineering';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(engineering)}
                />
            ) : (
                <MoneyBox
                    id={'engineering'}
                    allowNegative={false}
                    value={engineering}
                    onChange={(value) => set_engineering(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
